export const mapToRelativeTime = (
  datetimeString: string,
  t: (key: string, options?: { count: number }) => string,
  locale = 'en-GB',
) => {
  const diff = Date.now() - new Date(datetimeString).getTime();
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(minutes / 60);

  if (minutes === 0) return t('relative-time.just-now');
  if (minutes < 60)
    return t(
      diff > 0 ? 'relative-time.minutes-ago' : 'relative-time.minutes-in',
      { count: Math.abs(minutes) },
    );
  if (hours < 24)
    return t(diff > 0 ? 'relative-time.hours-ago' : 'relative-time.hours-in', {
      count: Math.abs(hours),
    });
  return new Date(datetimeString)
    .toLocaleDateString(locale, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    })
    .replace(/\s/g, ' ');
};
